<template>
    <svg width="61" height="55" viewBox="0 0 61 55" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M59.8197 47.6008L34.9016 2.83302C33.9953 1.41552 32.3169 0.542236 30.5001 0.542236C28.6832 0.542236 27.0048 1.41622 26.0985 2.83302L1.18045 47.6008C0.272715 49.0155 0.273418 50.7586 1.18115 52.1732C2.08959 53.5879 3.76725 54.4591 5.58201 54.4577H55.4181C57.2336 54.4584 58.9112 53.5879 59.819 52.1732C60.7267 50.7586 60.7274 49.0155 59.8197 47.6008ZM33.5003 44.9938H27.5005V38.994H33.5003V44.9938ZM33.5003 14.9936V35.9931H27.5005V14.9929L33.5003 14.9936Z"
            fill="#FFDB21"
        />
    </svg>
</template>
